import React, { useEffect, useState } from 'react';
import './area-list.scss';
import { userAxios } from '../../../config/axios';
import { FiEdit2 } from 'react-icons/fi'
import { AiOutlinePlus } from 'react-icons/ai'
import AdminPage from '../../../components/common/page/AdminPage';
import TableFilter from '../../../components/common/table-filter/TableFilter'
import EditArea from '../../../components/admin/edit-area/EditArea';
import Modal from '../../../components/common/modal/Modal'
import Spinner from '../../../components/common/spinners/SpinWithMessage'
import { RxDashboard } from 'react-icons/rx'

const AreaList = () => {
    const [area, setArea] = useState([])
    const [modal, setModal] = useState({ content: null, title: null, status: false })
    const [loading, setLoading] = useState('')

    useEffect(() => {
        setLoading('fetch')
        userAxios.get('/area').then((response) => {
            setArea(response.data)
            setLoading('')
        })
    }, [])

    const openModal = (title, data) => {
        setModal({
            content: <EditArea data={data || ''} setModal={setModal} setArea={setArea} />,
            title,
            status: true
        })
    }

    return (
        <div className="zone-list">
            <Modal modal={modal} setModal={setModal} />
            <AdminPage titleArray={['Branch Area list']}>
                <div className="table-border-div">
                    {area?.[0] ? <TableFilter srlNo={true} >
                        <table>
                            <thead>
                                <tr>
                                    <th>City name</th>
                                    <th>Assign date</th>
                                    <th>Tech list</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {area?.map((value, index) => {
                                    return <tr key={index}>
                                        <td>{value?.city_name}</td>
                                        <td>{value?.pr_get_data_date}</td>
                                        <td>{value?.technicians?.map((tech, idx) => <>{tech?.full_name}<br></br></>)}</td>
                                        <td>
                                            <div className='buttons' >
                                                <button title='Edit' onClick={() => openModal(`Edit ${value?.city_name}`, value)}
                                                    className='button-small-icon edit'><FiEdit2 /></button>
                                            </div>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </TableFilter>
                        : <Spinner message={loading ? 'fetch data...' : 'No data'} icon={!loading && <RxDashboard />} spin={loading} />
                    }
                </div>
            </AdminPage>
        </div>
    )
}

export default AreaList